<template>
  <base-dialog v-model="show" @close="close" :loadingTitle="loading">
    <template v-slot:title> Nội dung trình bày</template>
    <template #content>
      <v-card-text class="flex-grow-1 pa-0">
        <preview-simple-edit
          v-if="show"
          v-model="form.content"
          :fields="fields"
        ></preview-simple-edit>
      </v-card-text>
    </template>

    <template #extra-btn>
      <base-button color="primary" outlined @click="onSaveStyle()">
        Áp dụng
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import PreviewSimpleEdit from '@views/styles/preview/edit-simple.vue'
import { API_LAYER, API_STYLE } from '@/src/service/api'
export default {
  components: { PreviewSimpleEdit },
  props: {},
  data: () => ({
    show: false,
    loading: false,
    form: {},
    layer: {},
    fields: [],
  }),
  computed: {},
  methods: {
    async open(data) {
      this.layer = data
      const res = await API_LAYER.getFeatureType(data.id)
      this.show = true
      this.form = Object.assign(
        { workspace_id: null, layer_id: null, content: [] },
        res.data.info.style || {}
      )
      this.fields = res.data.attributes
    },
    async onSaveStyle() {
      this.loading = true
      try {
        this.form.workspace_id = this.layer.workspace_id
        this.form.layer_id = this.layer.id
        await API_STYLE.create(this.form)
        this.$emit('reset')
        this.close()
      } finally {
        this.loading = false
      }
    },
    close() {
      this.show = false
      this.loading = false
      this.form = {}
      this.fields = []
      this.layer = {}
    },
  },
}
</script>

<style scoped></style>
